import { Form } from 'formik';
import styled from 'styled-components';
import { ReactComponent as EditionSVGIcon } from 'src/assets/benefits-edit.svg';
import { FormInput as LibFormInput } from 'pg-ui-library';

export const PersonalInfoHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: center;
  justify-content: space-between;
  background-image: linear-gradient(106deg, #0f0c29 0%, #302b63 50%, #24243e 100%), linear-gradient(white, white);
  background-size:
    100% 20%,
    100% 80%;
  background-position: top, bottom;
  background-repeat: no-repeat;
  height: 500px;
  box-shadow: 0px 0px 6px #e3e3e3;
  border-radius: 10px;
  padding: 20px;
`;

export const EmployeeAvatar = styled.img`
  border-radius: 50%;
  width: 15vh;
  height: 15vh;
`;

export const Separator = styled.div`
  min-height: 4vh;
`;

export const MainTitle = styled.div`
  font-size: 2.5rem;
  font-weight: bold;
  margin: 0.5em;
`;

export const Container = styled(Form)`
  display: flex;
  flex-direction: column;
  background: white;
  height: 500px;
  flex-wrap: nowrap;
  border-radius: 10px;
  min-height: 250px;
  box-shadow: 0px 0px 6px #e3e3e3;
  @media only screen and (max-width: 1200px) {
    display: flex;
    flex-direction: column;
  }
`;

export const GeneralInfo = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  @media only screen and (max-width: 1200px) {
    width: 100%;
  }
`;

export const EmploymentInfo = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  @media only screen and (max-width: 1200px) {
    width: 100%;
  }
`;

export const FormTitle = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-left: 1.5em;
  align-items: center;
  svg:hover,
  svg:focus {
    fill: #fff;
  }
`;

export const FormTitleItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font: normal normal 600 22px/26px Biotif;
  margin: 21px 0px;
`;

export const EditIcon = styled(EditionSVGIcon)`
  width: 15px;
  margin-left: 2rem;
  & > path {
    fill: black;
  }
`;

export const FormRow = styled.div`
  display: flex;
  margin-left: 20px;
  @media only screen and (max-width: 818px) {
    display: flex;
    flex-direction: column;
  }
`;

export const GeneralInfoAvatarContainer = styled.div`
  display: flex;
  margin: 1em;
  @media only screen and (max-width: 818px) {
    display: flex;
    justify-content: center;
  }
`;

export const GeneralInfoFormContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  row-gap: 15px;
  width: 100%;
  input {
    pointer-events: none;
    border: none;
    outline: none;
    box-shadow: none;
    min-width: 320px;
    padding-left: 0px;
    font:
      normal normal normal 18px Biotif,
      SemiBold;
  }
  select {
    pointer-events: none;
    border: none;
    outline: none;
    box-shadow: none;
    padding-left: 0px;
    font:
      normal normal normal 18px Biotif,
      SemiBold;
    label {
      margin-top: 0px;
    }
  }
`;

export const FormInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 17rem;
  margin: 5px;
  select {
    margin-top: -5px;
  }
  input {
    margin-top: -5px;
  }
`;

export const FormInputLabel = styled.label`
  margin-top: -5px;
  font:
    normal normal normal 18px Biotif,
    SemiBold;
  color: #707070;
`;

export const PersonalInfoFormContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  row-gap: 15px;
  width: 100%;
  margin-left: 20px;
  input {
    pointer-events: none;
    border: none;
    outline: none;
    box-shadow: none;
    min-width: 340px;
    padding-left: 0px;
    font:
      normal normal normal 18px Biotif,
      SemiBold;
    font-weight: 500;

    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    #personalEmail {
      &::after {
        content: attr(value);
        position: absolute;
        background: #000;
        color: #fff;
        padding: 5px;
        border-radius: 3px;
        white-space: nowrap;
        bottom: 100%;
        left: 0;
        z-index: 10;
        display: none;
      }
      &:hover::after {
        display: block;
      }
    }
  }
  select {
    pointer-events: none;
    border: none;
    outline: none;
    box-shadow: none;
    padding-left: 0px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    font:
      normal normal normal 18px Biotif,
      SemiBold;
    label {
      margin-top: 0px;
    }
  }
`;

export const SeparatorLine = styled.div`
  height: 500px;
  align-self: center;
  min-width: 4vh;
  background: #f3f4f8;
  @media only screen and (max-width: 1200px) {
    display: flex;
    width: 100%;
    border-left: 0;
    height: 10px;
    align-self: center;
    margin: 0.5em;
    border-top: 10px solid #f3f4f8;
  }
`;

export const SeparatorLineStraight = styled.div`
  min-height: 1.5px;
  background-color: #9399b247;
  margin-bottom: 20px;
`;

export const FormInput = styled(LibFormInput)`
  flex: 1;
`;

export const SeparatorLineVertical = styled.div`
  width: 1px;
  height: 100%;
  background-color: black;
  margin: 0 20px;
`;

export const InputContainer = styled.div`
  text-align: center;
  input {
    pointer-events: none;
    border: none;
    outline: none;
    box-shadow: none;
    min-width: 320px;
    font:
      normal normal normal 18px Biotif,
      SemiBold;
  }
  label {
    font:
      normal normal normal 18px Biotif,
      SemiBold;
    color: #707070;
    flex: 0 0 40%;
  }
  p {
    margin: 10px;
    font:
      normal normal 600 24px/24px Biotif,
      SemiBold;
    letter-spacing: 0px;
    color: #1c1b3a;
  }
`;

export const PersonelInputContainer = styled.div`
  display: flex;
  width: 100%;
  margin: 0;
  padding: 0;
  margin-bottom: 0px;
  input {
    margin-top: -30px;
    pointer-events: none;
    border: none;
    outline: none;
    box-shadow: none;
    min-width: 320px;
    font:
      normal normal normal 18px Biotif,
      SemiBold;
    margin: 0;
  }
`;

export const PersonelInputLabel = styled.label`
  margin-top: 0px;
  font:
    normal normal normal 18px Biotif,
    SemiBold;
  color: #707070;
  flex: 0 0 90%;
`;

export const InputIcon = styled.img`
  height: auto;
  width: 24px;
`;

export const EmailIcon = styled(InputIcon)`
  width: 18px;
  left: 16px;
`;
